import React, { useState } from 'react';
import { Button, Input, Label } from '@ohif/ui-next';

interface LoginScreenProps {
  onLoginSuccess: () => void;
}

export function LoginScreen({ onLoginSuccess }: LoginScreenProps) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    try {
      const host = typeof window !== 'undefined' ? window.location.hostname : 'localhost';
      const response = await fetch(`http://${host}:3000/api/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      });

      if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        throw new Error(data.detail || 'Tài khoản hoặc mật khẩu không chính xác!');
      }

      const data = await response.json();
      sessionStorage.setItem('ohif_worklist_authenticated', 'true');
      sessionStorage.setItem('ohif_worklist_token', data.token);
      sessionStorage.setItem('user_role', data.user.role);
      sessionStorage.setItem('user_username', data.user.username);
      sessionStorage.setItem('user_fullname', data.user.fullname);
      onLoginSuccess();
    } catch (err: any) {
      setError(err.message || 'Không thể kết nối tới máy chủ xác thực.');
    }
  };

  return (
    <div className="flex h-screen w-screen items-center justify-center bg-black select-none text-foreground">
      <div className="w-full max-w-[380px] mx-4 animate-fade-in">
        <form
          onSubmit={handleLogin}
          className="bg-slate-900 border border-slate-800 rounded-lg p-6 shadow-xl flex flex-col space-y-5"
        >
          <div className="flex flex-col space-y-1.5 text-center">
            <h1 className="text-xl font-semibold text-white tracking-wide uppercase">
              Đăng nhập hệ thống
            </h1>
            <p className="text-xs text-muted-foreground">
              Vui lòng đăng nhập để truy cập
            </p>
          </div>

          <div className="flex flex-col space-y-3.5">
            <div className="grid gap-1">
              <Label htmlFor="username" className="text-xs text-muted-foreground uppercase font-medium">
                Tài khoản
              </Label>
              <Input
                id="username"
                type="text"
                autoComplete="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Nhập tài khoản"
                className="bg-black border-slate-800 text-white placeholder:text-slate-600 focus:border-primary transition-colors h-9 text-sm"
                required
              />
            </div>

            <div className="grid gap-1">
              <Label htmlFor="password" className="text-xs text-muted-foreground uppercase font-medium">
                Mật khẩu
              </Label>
              <Input
                id="password"
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Nhập mật khẩu"
                className="bg-black border-slate-800 text-white placeholder:text-slate-600 focus:border-primary transition-colors h-9 text-sm"
                required
              />
            </div>
          </div>

          {error && (
            <div className="bg-red-950/20 border border-red-900/40 rounded p-2.5 text-xs text-red-400 flex items-center gap-2">
              <svg className="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
              </svg>
              <span>{error}</span>
            </div>
          )}

          <Button
            type="submit"
            className="w-full h-9 bg-primary text-primary-foreground hover:bg-primary/90 font-medium text-sm rounded transition-colors"
          >
            Đăng nhập
          </Button>
        </form>
      </div>
    </div>
  );
}
